import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects, Types} from "components";
import {Button} from "reactstrap";
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {TextField} from '@material-ui/core';
import API from "@beardeddevops/react.api";

const breadcrumbStatic = [{
	name: 'AV Keys',
	url: '/admin/av_keys',
	icon: 'dashboard'
}];

export default class Av_Keys extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state = {
			showImportListModal: false,
			loadingModalData: false,
			countVariableByName: {},
			bitdefenderTotalLicenses: '0',
			bitdefenderOffsetNumber: '0',
			bitdefenderAlertThreshold: '0',
			malwarebytesTotalLicenses: '0',
			malwarebytesOffsetNumber: '0',
			malwarebytesAlertThreshold: '0',
		};
	}

	parseNumber = (value) => {
		const parsed = parseInt(value, 10);
		return Number.isNaN(parsed) ? 0 : parsed;
	}

	handleInputChange = (field) => (e) => {
		const value = e.target.value;
		if (/^\d*$/.test(value)) {
			this.setState({[field]: value});
		}
	}

	handleOffsetInputChange = (field) => (e) => {
		const value = e.target.value;
		if (/^-?\d*$/.test(value)) {
			this.setState({[field]: value});
		}
	}

	loadCountVariables = async () => {
		this.setState({loadingModalData: true});

		try {
			const model = new API.BuildClass(Types.Count_Variables._name, API.RequestType.READ);
			model.filter = {
				names: [
					'bitdefender_total',
					'bitdefender_offset',
					'bitdefender_alert_threshold',
					'malwarebytes_total',
					'malwarebytes_offset',
					'malwarebytes_alert_threshold'
				]
			};
			const response = await model.submit(null, "GET_ALL");
			const byName = response?.by_name || {};

			this.setState({
				countVariableByName: byName,
				bitdefenderTotalLicenses: String(byName.bitdefender_total?.amount ?? 0),
				bitdefenderOffsetNumber: String(byName.bitdefender_offset?.amount ?? 0),
				bitdefenderAlertThreshold: String(byName.bitdefender_alert_threshold?.amount ?? 0),
				malwarebytesTotalLicenses: String(byName.malwarebytes_total?.amount ?? 0),
				malwarebytesOffsetNumber: String(byName.malwarebytes_offset?.amount ?? 0),
				malwarebytesAlertThreshold: String(byName.malwarebytes_alert_threshold?.amount ?? 0),
			});
		} catch (error) {
			console.error('Failed to load count variables', error);
		} finally {
			this.setState({loadingModalData: false});
		}
	}

	upsertCountVariable = async (name, amount) => {
		const existing = this.state.countVariableByName[name];
		if (existing && existing.amount === this.parseNumber(amount)) {
			return true;
		}
		const numericAmount = this.parseNumber(amount);
		const requestType = existing?.pkey ? API.RequestType.UPDATE : API.RequestType.CREATE;
		const model = new API.BuildClass(Types.Count_Variables._name, requestType);

		if (existing?.pkey) {
			model.object.pkey = existing.pkey;
		}
		model.object.name = name;
		model.object.amount = numericAmount;

		await model.submit(null, 'POST');

		return true;
	}

	handleSave = async () => {
		try {
			await this.upsertCountVariable('bitdefender_total', this.state.bitdefenderTotalLicenses);
			await this.upsertCountVariable('bitdefender_offset', this.state.bitdefenderOffsetNumber);
			await this.upsertCountVariable('bitdefender_alert_threshold', this.state.bitdefenderAlertThreshold);
			await this.upsertCountVariable('malwarebytes_total', this.state.malwarebytesTotalLicenses);
			await this.upsertCountVariable('malwarebytes_offset', this.state.malwarebytesOffsetNumber);
			await this.upsertCountVariable('malwarebytes_alert_threshold', this.state.malwarebytesAlertThreshold);

			this.setState({showImportListModal: false});
		} catch (error) {
			console.error('Failed to save count variables', error);
		}
	}

	handleCancel = () => {
		this.setState({
			showImportListModal: false,
		});
	}

	render() {
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={this.props.history}>
					<Button data-cy="add-customer" onClick={async () => {
						await this.loadCountVariables();
						this.setState({showImportListModal: true});
					}} size={"sm"} color="primary">
						<i className="fa fa-users"/>&nbsp;&nbsp;Adjust AV Totals
					</Button>
				</Framework.Components.PageBar>
				<Collections.AvKeys />

				<Modal
					isOpen={this.state.showImportListModal}
					toggle={this.handleCancel}
					size={"lg"}
					backdrop={true}
				>
					<ModalHeader toggle={this.handleCancel}>
						Adjust AV Totals
					</ModalHeader>
					<ModalBody>
						<div className="row mb-3">
							<div className="col-12">
								<h6>BitDefender</h6>
							</div>
							<div className="col-md-4">
								<TextField
									margin="dense"
									label="Total Licenses"
									type="text"
									fullWidth
									value={this.state.bitdefenderTotalLicenses}
									onChange={this.handleInputChange('bitdefenderTotalLicenses')}
									variant="outlined"
									inputProps={{
										pattern: '[0-9]*'
									}}
								/>
							</div>
							<div className="col-md-4">
								<TextField
									margin="dense"
									label="Offset Number"
									type="text"
									fullWidth
									value={this.state.bitdefenderOffsetNumber}
									onChange={this.handleOffsetInputChange('bitdefenderOffsetNumber')}
									variant="outlined"
									inputProps={{
										pattern: '-?[0-9]*'
									}}
								/>
							</div>
							<div className="col-md-4">
								<TextField
									margin="dense"
									label="Alert Threshold"
									type="text"
									fullWidth
									value={this.state.bitdefenderAlertThreshold}
									onChange={this.handleInputChange('bitdefenderAlertThreshold')}
									variant="outlined"
									inputProps={{
										pattern: '[0-9]*'
									}}
								/>
							</div>
						</div>
						<div className="row">
							<div className="col-12">
								<h6>MalwareBytes</h6>
							</div>
							<div className="col-md-4">
								<TextField
									margin="dense"
									label="Total Licenses"
									type="text"
									fullWidth
									value={this.state.malwarebytesTotalLicenses}
									onChange={this.handleInputChange('malwarebytesTotalLicenses')}
									variant="outlined"
									inputProps={{
										pattern: '[0-9]*'
									}}
								/>
							</div>
							<div className="col-md-4">
								<TextField
									margin="dense"
									label="Offset Number"
									type="text"
									fullWidth
									value={this.state.malwarebytesOffsetNumber}
									onChange={this.handleOffsetInputChange('malwarebytesOffsetNumber')}
									variant="outlined"
									inputProps={{
										pattern: '-?[0-9]*'
									}}
								/>
							</div>
							<div className="col-md-4">
								<TextField
									margin="dense"
									label="Alert Threshold"
									type="text"
									fullWidth
									value={this.state.malwarebytesAlertThreshold}
									onChange={this.handleInputChange('malwarebytesAlertThreshold')}
									variant="outlined"
									inputProps={{
										pattern: '[0-9]*'
									}}
								/>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button onClick={this.handleCancel} color="secondary">
							Cancel
						</Button>
						<Button onClick={this.handleSave} color="primary" disabled={this.state.loadingModalData}>
							Save
						</Button>
					</ModalFooter>
				</Modal>

			</div>


		)
	}
}